import { render, staticRenderFns } from "./UserDismiss.vue?vue&type=template&id=d2b9b0a6&"
import script from "./UserDismiss.vue?vue&type=script&lang=js&"
export * from "./UserDismiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports